import React from 'react';

const AreaDetails = ({ areaUnits, areaDetails, setAreaDetails, propertyTypeSelectedFields, errors, clearError }) => {
  const updateAreaDetails = (index, field, value) => {
    const updated = [...areaDetails];
    updated[index][field] = value;
    setAreaDetails(updated);
    
    // Clear area size error when user starts typing
    if (updated[index].label === 'area' && field === 'value' && clearError) {
      clearError('areaSize');
    }
  };

  const visibleAreaDetails = areaDetails.filter(detail =>
    propertyTypeSelectedFields.includes(detail.label)
  );

  if (visibleAreaDetails.length === 0) return null;

  return (
    <div>
      {visibleAreaDetails.map((detail, index) => {
        const originalIndex = areaDetails.findIndex(item => item.label === detail.label);
        const isAreaSize = detail.label === 'area';
        
        return (
          <div className="row mb-2" key={detail.name}>
            <div className="col-md-4">
              <label className="form-label">
                {detail.name}
                {isAreaSize && <span className="text-danger">*</span>}
              </label>
              <input
                type="text"
                className={`form-control ${errors?.areaSize && isAreaSize ? 'is-invalid' : ''}`}
                placeholder="Value"
                value={detail.value}
                onChange={(e) => updateAreaDetails(originalIndex, 'value', e.target.value)}
              />
              {errors?.areaSize && isAreaSize && (
                <div className="text-danger small mt-1">{errors.areaSize}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">Unit</label>
              <select
                className="form-select"
                value={detail.unit}
                onChange={(e) => updateAreaDetails(originalIndex, 'unit', e.target.value)}
              >
                {areaUnits.map((unit) => (
                  <option key={unit._id} value={unit._id}>
                    {unit.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        );
      })}
    </div>
  );
};


export default AreaDetails;
